/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Point_4Inputs */

const en_services_svc_save_point_4 = /** @type {(inputs: Services_Svc_Save_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built in n8n or custom code, whichever fits the process`)
};

const lv_services_svc_save_point_4 = /** @type {(inputs: Services_Svc_Save_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidots n8n vai kodā, atkarībā no procesa`)
};

/**
* | output |
* | --- |
* | "Built in n8n or custom code, whichever fits the process" |
*
* @param {Services_Svc_Save_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_point_4 = /** @type {((inputs?: Services_Svc_Save_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_point_4(inputs)
	return en_services_svc_save_point_4(inputs)
});